import type { BoothArea } from './booths'

type HallStyle = {
  name: string
  /** Standflaeche im Plan */
  color: string
  /** Pille beim Hover: Hintergrund und Text/Rand */
  colorBase: string
  colorText: string
}

/**
 * Die Halle kommt aus dem Plan selbst, nicht aus `location_site` in Storyblok —
 * so passt die Farbe der Pille immer zur eingefaerbten Standflaeche.
 */
export const halls: Record<BoothArea['hall'], HallStyle> = {
  foyer: {
    name: 'Foyer',
    color: '#86B361',
    colorBase: '#CEE1C0',
    colorText: '#86B360',
  },
  saal: {
    name: 'Grosser Saal',
    color: '#F9B119',
    colorBase: '#FDE0A3',
    colorText: '#F6A201',
  },
  lindahof: {
    name: 'Lindahof',
    color: '#E30613',
    colorBase: '#FACDCF',
    colorText: '#D41417',
  },
}
